import axios from 'axios';

import * as urls from 'constants/urls';

export const getMenuCountersHandler = () => axios.get(urls.MENU_COUNTERS.stringify());
export const getRequestCountersHandler = () => axios.get(urls.REQUEST_COUNTERS.stringify());
export const getApprovalPersonCountersHandler = () => axios.get(urls.APPROVAL_PERSON_COUNTERS.stringify());
export const getApprovalProjectCountersHandler = () => axios.get(urls.APPROVAL_PROJECT_COUNTERS.stringify());
